//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    itemsData: {
      default: () => ({})
    },
    pickData: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  computed: {
    totalAmount () {
      let v = 0
      v = _.reduce(this.pickData, (memo, item) => {
        return memo + item.totalAmount
      }, 0)
      return v
    }
  },
  components: {
  },
  methods: {
    handleSubmit (row) {
      // console.log('items', items)
      this.$emit('update:visible', false)
      /**/
      let data = {items: JSON.stringify(this.itemsData)}
      this.loading = true
      this.$axios.post('/mtea/store/admin/purchase/pick/create', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
        this.$emit('update:visible', false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
